export const UserRoles = {
  USER: "USER",
  ADMIN: "ADMIN",
};

export const ExtendedUserRoles = {
  ...UserRoles,
  SUPERADMIN: "SUPERADMIN",
};
